/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';

@Component({
  selector: 'well-terms-and-conditions-preview-dialog',
  templateUrl: './terms-and-conditions-preview-dialog.component.html',
  styleUrls: ['./terms-and-conditions-preview-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermsAndConditionsPreviewDialogComponent {
  template = input<string | undefined>(undefined);
  comments = input<string | undefined>(undefined);
  status = input<string | undefined>(undefined);

  displayDialog = model<boolean>(false);
  displayDialogChange = output<boolean>();
  hideDialog() {
    this.displayDialog.set(false);
    this.displayDialogChange.emit(false);
  }
}
